// extracted by mini-css-extract-plugin
export default {"cardLabelsContainer":"cardLabels-module__cardLabelsContainer__mxwOp"};